import { VStack, Text } from "@gluestack-ui/themed";
import { AlertModalBodyProps } from "./types";
import { LottieAnimation } from "@repo/core/components/core/LottieAnimation";
import { Icon } from "@repo/core/components/core/Icon";
import Spinner from "@repo/core/components/core/Spinner";

export const AlertModalBody = ({
  text,
  title,
  icon,
  iconColor,
  iconVariant,
  lottieFileConfig,
  isLoading,
  showIcon,
  children
}: AlertModalBodyProps) => {
  const renderAnimation = () => {
    if (isLoading) return <Spinner size={20} />;
    if (!lottieFileConfig) return null;
    return <LottieAnimation {...lottieFileConfig} />;
  };

  return (
    <VStack width="$full" flex={1} alignItems="center" gap="$4">
      <VStack gap="$2" alignItems="center">
        {renderAnimation()}

        {icon && showIcon && !isLoading ? (
          <Icon name={icon} color={iconColor} variant={iconVariant} />
        ) : null}

        {title ? (
          <Text
            textAlign="center"
            color="$textLight900"
            fontWeight={600}
            size="lg"
          >
            {title}
          </Text>
        ) : null}
      </VStack>

      {text ? (
        <Text
          textAlign="center"
          color="$textLight900"
          fontWeight={400}
          size={"sm"}
          mb="$4"
          flex={1}
          maxWidth={"$72"}
        >
          {text}
        </Text>
      ) : (
        <VStack width="$full" flex={1}>
          {children}
        </VStack>
      )}
    </VStack>
  );
};
